import React from 'react';
import Routes from './routes';
import Toolbar from './components/Toolbar';
import { useDispatch, useSelector } from 'react-redux';
import { useAsync, useUpdateEffect } from 'react-use';
import actions from 'state/actions';
import services from 'services';
import selectors from 'state/selectors';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

interface Props {
  idProgram: number;
}

const Configurator = (props: Props) => {
  const { idProgram } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();
  const companies = useSelector(selectors.app.getCompanies);
  const templates = useSelector(selectors.configurator.selectTemplates);
  const location = useLocation();
  const activeTemplateId = useSelector(selectors.configurator.selectActiveTemplateId);

  // Getting templates and setting first as default
  useAsync(async () => {
    try {
      const { data: templates } = await services.getTemplates(idProgram);
      dispatch(actions.configurator.setTemplates(templates));
      if (templates?.length) {
        const { idTemplate, description } = templates[0];
        dispatch(actions.configurator.setActiveTemplateId(idTemplate));
        history.push(`${path}/${description}`);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  // Used to redirect to the first View when menu item get clicked again
  useUpdateEffect(() => {
    if (location.pathname === path) {
      if (templates?.length) {
        const { idTemplate, description } = templates[0];
        dispatch(actions.configurator.setActiveTemplateId(idTemplate));
        history.push(`${path}/${description}`);
      }
    }
    const urlActiveOption = history.location.pathname.substring(path.length + 1);

    // used to returns on previous page when click on back arrow
    const findTemplate = templates.find((el) => el.idTemplate === activeTemplateId);
    if (findTemplate?.description !== urlActiveOption) {
      const templateToRedirect = templates.find((el) => el.description === urlActiveOption);
      if (templateToRedirect) dispatch(actions.configurator.setActiveTemplateId(templateToRedirect.idTemplate));
    }
  }, [location.pathname]);

  return (
    <>
      {companies ? <Toolbar /> : null}
      <Routes />
    </>
  );
};

export default Configurator;
